export default __webpack_public_path__ + "static/media/Soon.8bbd2b93.gif";